import { Link } from 'react-router-dom';
import { categories, comics } from '@/mocks/comics';

export default function Footer() {
  return (
    <footer className="border-t border-background-200/60 bg-background-100">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6">
        <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-skull-line text-xl" aria-hidden="true"></i>
              </span>
              <span className="font-heading text-lg tracking-wide text-foreground-950">
                嘿嘿<span className="text-primary-500">漫画网</span>
              </span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600">
              专注深夜档、重口味与暗黑向剧情漫画，收录都市诡异、悬疑烧脑、血浆恐怖、暗黑人性等题材，为暗黑美学爱好者打造精神栖所。
            </p>
          </div>

          <nav aria-label="栏目导航">
            <h4 className="text-sm font-bold text-foreground-950">栏目分类</h4>
            <ul className="mt-4 space-y-3">
              {categories.map((c) => (
                <li key={c.slug}>
                  <Link to={`/category/${c.slug}`} className="text-sm text-foreground-600 transition-colors hover:text-primary-400">
                    {c.name} · {c.en}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          <nav aria-label="快速链接">
            <h4 className="text-sm font-bold text-foreground-950">快速链接</h4>
            <ul className="mt-4 space-y-3">
              <li><Link to="/" className="text-sm text-foreground-600 transition-colors hover:text-primary-400">首页</Link></li>
              <li><Link to="/about" className="text-sm text-foreground-600 transition-colors hover:text-primary-400">关于我们</Link></li>
              <li><Link to="/contact" className="text-sm text-foreground-600 transition-colors hover:text-primary-400">联系我们</Link></li>
            </ul>
          </nav>

          <div>
            <h4 className="text-sm font-bold text-foreground-950">热门追更</h4>
            <ul className="mt-4 space-y-3">
              {comics.slice(0, 4).map((c) => (
                <li key={c.id}>
                  <Link to={`/comic/${c.id}`} className="text-sm text-foreground-600 transition-colors hover:text-primary-400">
                    {c.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-background-200/60 pt-6 sm:flex-row">
          <p className="text-xs text-foreground-500">
            © {new Date().getFullYear()} 嘿嘿漫画网 · 仅供内容展示与学习交流使用
          </p>
          <div className="flex items-center gap-4 text-foreground-500">
            <a href="#" rel="nofollow noopener" aria-label="微博" className="transition-colors hover:text-primary-400">
              <i className="ri-weibo-line text-base" aria-hidden="true"></i>
            </a>
            <a href="#" rel="nofollow noopener" aria-label="B站" className="transition-colors hover:text-primary-400">
              <i className="ri-video-line text-base" aria-hidden="true"></i>
            </a>
            <a href="#" rel="nofollow noopener" aria-label="邮箱" className="transition-colors hover:text-primary-400">
              <i className="ri-mail-line text-base" aria-hidden="true"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}